<template>
    <div>
        <div v-if="leadSinAsignar">
            <v-card color="grey lighten-4" flat tile style="margin-top: 20px">
                <v-toolbar>
                    <v-toolbar-title>
                        <h3>
                            Certificado:
                            {{
                                this.poliza.poliza != "null"
                                    ? "#" + this.poliza.poliza
                                    : "Aun sin certificado"
                            }}
                        </h3>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <h3>Plan: {{ nombreProducto }}</h3>
                    <v-spacer></v-spacer>

                    <v-spacer></v-spacer>
                    <h3>Mensualidad: {{ toCurrency(poliza.montoPrimerPago) }}</h3>
                    <v-spacer></v-spacer>

                    <v-btn v-if="canEdit" icon @click="verEmisionEditable()">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn @click="goBack()" style="background-color: #ff0042; color: white;">
                        Regresar
                    </v-btn>
                </v-toolbar>

            </v-card>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="7">
                    <v-form>
                        <v-row>
                            <v-col>
                                <v-stepper non-linear>
                                    <v-stepper-header class="d-flex justify-space-around">
                                        <v-stepper-step step="1" editable>
                                            Cotizacion / Poliza
                                        </v-stepper-step>
                                        <v-stepper-step step="2" editable>
                                            Datos del cliente
                                        </v-stepper-step>
                                        <v-stepper-step step="3" editable v-if="hasEndoso">
                                            Detalles de endosos
                                        </v-stepper-step>
                                    </v-stepper-header>

                                    <v-stepper-items>
                                        <v-stepper-content step="1">

                                            <v-row style="padding: 20px; margin-top: -35px">
                                                <v-col :cols="4">
                                                    <v-text-field label="Póliza aseguradora"
                                                        v-model="poliza.polizaAseguradora" readonly>
                                                    </v-text-field>
                                                </v-col>

                                            </v-row>
                                            <v-row style="padding: 20px; margin-top: -35px">
                                                <v-col :cols="tipoContratanteVisible ? 3 : 4">
                                                    <v-text-field label="Cliente" v-model="poliza.newCliente" readonly>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col :cols="tipoContratanteVisible ? 3 : 4">
                                                    <v-autocomplete label="Plan" v-model="poliza.productos"
                                                        :items="currentProducto ? [currentProducto] : []" item-text="nombre" item-value="id"
                                                        placeholder="Requerido" readonly :rules="[$rules.required]">
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col :cols="tipoContratanteVisible ? 3 : 4">
                                                    <v-text-field label="Fecha de Emisión" prepend-icon="mdi-calendar"
                                                        v-model="poliza.emisionDate" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="3" v-if="tipoContratanteVisible">
                                                    <v-select label="Tipo de contratante"
                                                        v-model="poliza.tipo_contratante" :items="tipos_contratante"
                                                        readonly item-text="text" item-value="value">
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="4">
                                                    <v-text-field label="Estatus de la Póliza" v-model="poliza.status"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="poliza.status == 'Cancelada'">
                                                    <v-text-field label="Fecha de Cancelación"
                                                        prepend-icon="mdi-calendar" v-model="poliza.canceladaDate"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="
                                                    poliza.status == 'Finalizada' ||
                                                    poliza.status == 'Cancelada'
                                                ">
                                                    <v-select label="Motivo de Cancelación / Finalización"
                                                        v-model="poliza.canceladaFinalizadaMotivo"
                                                        :items="motivosCancelacionFiltrados" readonly
                                                        item-text="motivoCancelacion"
                                                        item-value="motivoCancelacion"></v-select>
                                                </v-col>

                                                <v-col :cols="isPagadaTotalOrRenovada ? 3 : 4">
                                                    <v-text-field label="Inicio de Vigencia" v-model="poliza.inicioDate"
                                                        prepend-icon="mdi-calendar" readonly></v-text-field>
                                                </v-col>

                                                <v-col :cols="isPagadaTotalOrRenovada ? 3 : 4">
                                                    <v-text-field label="Fin de Vigencia" v-model="poliza.finDate"
                                                        prepend-icon="mdi-calendar" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="3" v-if="isPagadaTotalOrRenovada">
                                                    <v-text-field label="Póliza renovada por" v-model="poliza.anterior"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col :cols="isPagadaTotalOrRenovada ? 3 : 4">
                                                    <v-text-field label="Pago mensual" v-model="poliza.montoSubsecuente"
                                                        readonly prefix="$"></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="No. Cotización / Lead ID"
                                                        v-model="poliza.leadId" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="6" v-if="
                                                    poliza.polizaSustituida &&
                                                    poliza.status == 'Cancelada'
                                                ">
                                                    <v-text-field label="Póliza de sustitución"
                                                        v-model="poliza.polizaSustituida" readonly append-icon="mdi-eye"
                                                        @click:append="
                                                            $router.push({
                                                                name: 'emision',
                                                                params: { uuid: poliza.polizaSustituida },
                                                            })
                                                            "></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="poliza.status == 'Finalizada'">
                                                    <v-text-field label="Fecha de Finalización"
                                                        v-model="poliza.finalizadaDate" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Periodicidad de pago"
                                                        v-model="poliza.periodicidad" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Periodicidad de pago"
                                                        v-model="poliza.periodicidad" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Años" v-model="years" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Número de cuotas" v-model="poliza.numeroCuotas"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Forma de Pago" v-model="poliza.formaPago"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Fecha de primer pago"
                                                        v-model="poliza.fechaPrimerPago" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias && esRenovada">
                                                    <v-text-field label="Fecha de renovación"
                                                        v-model="poliza.renovadaDate" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias && esRenovada">
                                                    <v-text-field label="Numero de Renovaciones"
                                                        v-model="poliza.renovadaNum" readonly>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias">
                                                    <v-text-field label="Mes de membresia" v-model="poliza.mesMembresia"
                                                        readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="esAsistencias && emision.fechaReactivacion">
                                                    <v-text-field label="Fecha de reactivación"
                                                        v-model="poliza.reactivadaDate" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col v-if="showBotonConfirmacion" cols="12">
                                                    <div class="d-flex justify-end">
                                                        <v-btn color="primary" @click="showConfirmationDialog = true">
                                                            <v-icon small class="mr-2">mdi-chat</v-icon>
                                                            <span>Enviar y Validar Código SMS</span>
                                                        </v-btn>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="showResponse && isAdmin">
                                                <v-col cols="12" md="8" lg="6">
                                                    <div>
                                                        <p> Respuesta de aseguradora </p>
                                                        <span class="text-red"> {{ this.emision.response }}</span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="emision && emision.ramo == 'ASISTENCIAS'" dense justify="end">
                                                <v-col cols="12" md="8" lg="6">
                                                    <agregarTelefonoButton :tarjeta="emision.tarjeta"
                                                        :telefono="emision.telefonoContacto" :emisionId="emision.id">
                                                    </agregarTelefonoButton>
                                                </v-col>
                                            </v-row>
                                        </v-stepper-content>
                                        <v-stepper-content step="2">
                                            <v-row style="padding: 20px; margin-top: -35px">
                                                <v-col cols="4">
                                                    <v-select label="Tipo de cliente" v-model="poliza.tipo_cliente"
                                                        readonly :items="tipos_cliente"
                                                        :rules="[$rules.required]"></v-select>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Tipo de Persona (Régimen)"
                                                        v-model="poliza.regimen" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen == 'Moral'">
                                                    <v-text-field label="Razón Social" v-model="poliza.razonSocial"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Nombre(s)" v-model="poliza.nombres"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Apellido Paterno"
                                                        v-model="poliza.apellidoPaterno" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Apellido Materno"
                                                        v-model="poliza.apellidoMaterno" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="
                                                    poliza.regimen != 'Moral' && poliza.regimen != null
                                                ">
                                                    <v-select label="Estado Civil"
                                                        :items="['Soltero(a)', 'Casado(a)', 'Unión Libre']" readonly
                                                        v-model="poliza.statusCivil"
                                                        :rules="[$rules.required]"></v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Fecha de Nacimiento"
                                                        v-model="poliza.fechaNacimiento" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field v-model="poliza.edad" label="EDAD"
                                                        placeholder="Requerido" :disabled="true" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="RFC" v-model="poliza.rfc"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Género" v-model="poliza.selectedGenero"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Teléfono" v-model="poliza.celular"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Correo Electrónico"
                                                        v-model="poliza.correoElectronico" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Reactivacion"
                                                        v-model="poliza.reactivacion" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col v-if="poliza.regimen == 'Física'" cols="4">
                                                    <v-select v-model="poliza.facturar" label="¿Desea facturar?"
                                                        :items="facturacionItems" readonly></v-select>
                                                </v-col>
                                                <v-col v-if="poliza.facturar && poliza.regimen == 'Física'" cols="4">
                                                    <v-select v-model="poliza['regimen-fiscal']" label="Tipo de régimen"
                                                        :items="tipoRegimenItems" readonly></v-select>
                                                </v-col>
                                                <v-col v-if="poliza.facturar && poliza.regimen == 'Física'" cols="4">
                                                    <v-select v-model="poliza.cfdi" label="Concepto CFDI"
                                                        :items="conceptoCFDIItems" readonly></v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Calle" v-model="poliza.calle" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="No. Exterior" v-model="poliza.num_exterior"
                                                        readonly :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="No. Interior" v-model="poliza.num_interior"
                                                        readonly :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Colonia" v-model="poliza.colonia" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Código Postal" v-model="poliza.codigoPostal"
                                                        v-mask="'#####'" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != null && !esAsistencias">
                                                    <v-select label="Estado de la República"
                                                        v-model="poliza.estadoRepublicaSelected" readonly
                                                        :items="ESTADOS_MEXICO" item-text="name" item-value="id"
                                                        :rules="[$rules.required]">
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Municipio" v-model="poliza.municipio" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-text-field label="Año en que se construyo"
                                                        v-model="poliza.años_construccion" type="number" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-select label="Tipo de construcción" readonly :items="['Maciza']"
                                                        v-model="poliza.tipo_construccion" :rules="[$rules.required]">
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-text-field label="No. de Pisos" v-model="poliza.num_pisos"
                                                        type="number" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-text-field label="Piso en el que vive" v-model="poliza.piso_vive"
                                                        type="number" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="8" style="padding-bottom:5%" v-if="!esAsistencias">
                                                    <v-textarea label="Dirección" :rules="[$rules.required]"
                                                        v-model="poliza.direccion" rows="1" auto-grow readonly>
                                                    </v-textarea>
                                                </v-col>
                                                <v-col cols="6" v-if="esCelular">
                                                    <v-text-field label="Marca y Modelo Celular"
                                                        :value="emision.modeloMarcaCelular" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" v-if="esCelular">
                                                    <v-text-field label="Precio Factura Celular"
                                                        :value="emision.precioFacturaCelular || 0" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-stepper-content>
                                        <v-stepper-content step="3">
                                            <template>
                                                <v-simple-table fixed-header>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">
                                                                    Tipo de endoso
                                                                </th>
                                                                <th class="text-center">
                                                                    Fecha
                                                                </th>
                                                                <th class="text-center">
                                                                    Detalle de endoso
                                                                </th>
                                                                <th class="text-center">
                                                                    Usuario
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in jsonEndosoInfo" :key="item.tipoEndoso">
                                                                <td class="text-center">
                                                                    {{ item.tipoEndoso }}
                                                                </td>
                                                                <td class="text-center">
                                                                    {{ item.fechaEndoso }}
                                                                </td>
                                                                <td class="text-center">
                                                                    {{ item.detalleEndoso }}
                                                                </td>
                                                                <td class="text-center">{{ item.usuario }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-stepper-content>
                                    </v-stepper-items>
                                </v-stepper>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-tooltip bottom :disabled="renovatePolicy">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-if="canViewManualRenewalButton" v-bind="attrs" v-on="on" style="margin-left: 30px;">
                                <v-btn color="primary" dark :disabled="!renovatePolicy"
                                    @click="showRenovationModal = true">
                                    Renovar manualmente</v-btn>
                            </span>
                        </template>
                        <span>{{ manualRenewalDisabledReason }}</span>
                    </v-tooltip>

                    <v-btn color="primary" dark v-if="canUpdatePolicy" @click="showRenovationUpdateModal = true"
                        style="margin-left: 30px;">
                        Pedir actualizacion de poliza aseguradora</v-btn>
                    <div style="padding: 30px;"
                        v-if="this.poliza.interaccion_aseguradora != null && this.poliza.isErrorEscalado !== true">
                        <v-row>
                            <p class="text-h6">Se ha presentado una incidencia al cotizar / emitir con la aseguradora,
                                favor de revisar la
                                información ingresada, en caso de necesitarlo escalarlo a la aseguradora mediante el
                                siguiente botón</p>
                            <span class="text-red">Mensaje: {{ JSON.parse(this.poliza.interaccion_aseguradora).message
                            }}</span>
                        </v-row>
                        <v-row class="justify-center mt-5">
                            <v-btn large color="primary" @click="showEscalarAseguradoraConfirmDialog = true">
                                Escalar con la aseguradora
                            </v-btn>
                        </v-row>
                    </div>
                </v-col>

                <v-col cols="5">
                    <CuotasCard :cuotas="cuotas" :search="search" :loading="loading"
                        :customFilter="filterOnlyCapsText" />
                    <DocumentosCard :documentos="documentos" :loading="loading" :customFilter="filterOnlyCapsText"
                        :polizaId="poliza.id" />
                    <EmailsCard :polizaId="poliza.id" :correos="correos" :loading="loading"
                        :customFilter="filterOnlyCapsText" :correoAgente="correoAgente" />

                    <Beneficiarios v-if="load && !esCelular" :emisionId="emision.id" :emisionStatus="poliza.status"
                        :rfcPoliza="poliza ? poliza.rfc : ''" />
                    <SolicitudesEmision v-if="load" :emisionId="emision.id" :emision="emision" />
                </v-col>
            </v-row>
            <!-- Error dialog -->
            <v-dialog v-model="errorApiDialog" max-width="500">
                <v-card class="border-red">
                    <v-card-title class="dialog-title text-red ">
                        ERROR API
                    </v-card-title>

                    <v-card-text class="text-body-1 mt-2  text-center ">
                        <div class="mb-2 text-black ">
                            Se ha presentando un error al momento de emitir por parte de la aseguradora.
                        </div>
                        <div class="text-black">
                            Reportar al equipo de soporte mandando el link de esta emisión.
                        </div>
                    </v-card-text>

                    <v-card-actions class="justify-end pa-4">
                        <v-btn style="background-color: #ff0042; color: white;" @click="errorApiDialog = false">
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- MODAL CONFIRMACION ESCALAR CON ASEGURADORA -->
            <v-dialog v-model="showEscalarAseguradoraConfirmDialog" max-width="550px">
                <v-card class="card-dialog">
                    <v-card-title class="text-h5 justify-center">¿Estás seguro?</v-card-title>
                    <v-card-text class="text-body-1 mt-2  text-center ">
                        <div class="mb-2 text-black">
                            Esto enviará un correo a los responsables con los datos necesarios para escalar la
                            incidencia con la
                            aseguradora.
                            Asegúrate de guardar la información de la emisión en caso de necesitar un estatus posterior.
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end pa-4">
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="showEscalarAseguradoraConfirmDialog = false">
                            Cerrar
                        </v-btn>
                        <v-btn color="primary" @click="sendMailErrorAseguradora">
                            Confirmar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <div v-else>
            <v-alert prominent type="error">
                <v-row align="center">
                    <v-col class="grow">
                        Ups parece que esta Venta no te corresponde" Por favor valida con tu
                        supervisor.
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="goBack()" elevation="2" style="background-color: white; color: black;">
                            Regresar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </div>

        <policy-code-dialog v-if="showConfirmationDialog" :show="showConfirmationDialog" :policy="poliza"
            @close="showConfirmationDialog = false" @policySuccess="policySuccess"></policy-code-dialog>

        <v-dialog v-model="showRenovationModal" persistent max-width="400">
            <v-card height="170" class="d-flex flex-column">
                <v-card-title class="text-h5 justify-center">
                    Renovar manualmente
                </v-card-title>
                <v-card-text class="justify-center">
                    ¿Estás seguro de que quieres renovar manualmente?</v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" text @click="showRenovationModal = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="renovarManualmente()" :disabled="loading" :loading="loading">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showRenovationUpdateModal" persistent max-width="400">
            <v-card height="170" class="d-flex flex-column">
                <v-card-title class="text-h5 justify-center">
                    Actualizar poliza aseguradora
                </v-card-title>
                <v-card-text class="justify-center">
                    ¿Estás seguro de que quieres buscar actualizacion de la poliza aseguradora?</v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" text @click="showRenovationUpdateModal = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="actualizarPolizaRenovacion()" :disabled="loading" :loading="loading">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { ESTADOS_MEXICO, getStatusEmisionNombre, getFormaPagoNombre, getEstadoNombre } from "@/constants";
import { getLeadBradescardById } from "@/services/leadService";
import { getCuotasByEmisionId } from "@/services/cuotaService";
import CuotasCard from "./components/cards/CuotasCard.vue";
import EmailsCard from "./components/cards/EmailsCard.vue";
import { getCotizacionById } from "@/services/cotizacionService";
import { getProductoById } from "../../../components/productos/productosService";
import DocumentosCard from "./components/cards/DocumentosCard.vue";
import { emisionRenovarProductos } from "@/services/renovacionService";
import { sendMailEscaladoAseguradora } from '../../../services/emisionService.js'
import { getMotivosCancelacion } from "@/services/motivosCancelacionService";
import Beneficiarios from "./components/Beneficiarios.vue";
import SolicitudesEmision from "./components/SolicitudesEmision.vue";
import agregarTelefonoButton from "../../../components/telefonoContacto/agregarTelefonoButton.vue";
import { actualizarPolizaAseguradoraRenovacion, getEmisionById } from "@/services/emisionService.js";


export default {
    components: {
        DocumentosCard,
        EmailsCard,
        CuotasCard,
        Beneficiarios,
        SolicitudesEmision,
        agregarTelefonoButton,
        "policy-code-dialog": () =>
            import("@/components/emision/validatePolicyCode.vue"),
    },
    computed: {
        esRenovada() {
            return this.emision?.renovacion && this.emision?.renovacion != 0;
        },
        esAsistencias() {
            return this.emision?.asistencias == true;
        },
        nombreProducto() {
            if (!this.currentProducto) return "Cargando...";
            return `${this.currentProducto.nombre} - ${this.currentProducto.producto_lead}`;
        },
        canEdit() {
            var canView = false;
            var roles = [];
            var isAgent = false;

            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesToView = [
                "ADMIN",
                "MESADECONTROL",
                "OPERACIONES",
                "OPERADOR",
                "ADMINCC",
                "MANAGERCC",
                "AGENTCC",
                "COORDINADOR",
                "OPERADORSERVICIOS",
                "SUPERVISOR",
                "GERENTE",
                "ADMINCUENTA",
                "AGENTCCELITE"
            ];
            roles.forEach((element) => {
                if (rolesToView.includes(element)) {
                    canView = true;
                }
            });
            roles.forEach((element) => {
                if ("AGENTCC" == element || "AGENTCCELITE" == element) {
                    isAgent = true;
                }
            });
            if (this.poliza.status != "Nueva" && isAgent) {
                canView = false;
            }

            return canView;
        },

        esCelular() {
            if (!this.poliza || !this.poliza.productos) return false;
            const productoFound = this.currentProducto
            return !!productoFound && productoFound.nombre.includes("Seguro Celular");
        },

        showBotonConfirmacion() {
            return this.poliza && this.poliza.status == "Emitido el certificado";
        },
        tipoContratanteVisible() {
            return this.productoAseguradora === "Hogar";
        },
        isPagadaTotalOrRenovada() {
            return (
                this.poliza.status === "Pagada Total" ||
                this.poliza.status === "Renovada"
            );
        },
        showResponse() {
            const result = this.hasError;
            return result;
        },
        hasError() {
            if (!this.emision || !this.emision.response) return false;

            const code = this.emision.response.code;
            return code !== undefined && code !== null && code !== 200;
        },
        isAdmin() {
            return this.roles.some(role => ["ADMIN"].includes(role.rol));
        },
        hasManualRenewalRole() {
            return this.roles.some(role => ["ADMIN", "GESTORDATOS"].includes(role.rol));
        },
        canViewManualRenewalButton() {
            return this.hasManualRenewalRole;
        },
        manualRenewalDisabledReason() {
            if (!this.emision) return "La emisión aún no está cargada.";
            if (![1, 2, 3, 6].includes(this.emision.status)) {
                return "La póliza no se encuentra en un estatus válido para renovar.";
            }
            if (!this.currentProducto) return "El producto de la póliza aún no está cargado.";
            if (!this.productoRenovable) return "El producto no está habilitado para renovación manual.";
            if (!this.emision.fechaEmision) return "La póliza no tiene fecha de emisión.";

            const fechaRenovable = moment(this.emision.fechaEmision, "YYYY-MM-DD HH:mm:ss").add(1, "year");
            if (!fechaRenovable.isValid()) return "La fecha de emisión no es válida.";
            if (!moment().isAfter(fechaRenovable, "day")) {
                return `La póliza podrá renovarse a partir del ${fechaRenovable.format("DD/MM/YYYY")}.`;
            }

            return "";
        }

    },

    data() {
        return {
            ESTADOS_MEXICO,
            tipos_cliente: [
                { text: "Titular", value: "titular" },
                { text: "Asegurado", value: "asegurado" },
            ],
            generoList: ["Masculino", "Femenino"],
            regimentList: ["Física", "Moral"],
            visible: false,
            currentProducto: null,
            loading: false,
            infoLead: null,
            load: false,
            search: "",
            roles: JSON.parse(localStorage.getItem("roles")),
            rolesList: JSON.parse(localStorage.getItem("roles"))[0].rol,
            newCorreoDialog: false,
            dialogCorreo: false,
            correoOpen: {},
            documentsDialog: false,
            dialogDetalleDocumentos: false,
            detallesDocumento: {},
            accionGuardar: false,
            showEscalarAseguradoraConfirmDialog: false,
            errorApiDialog: false,
            poliza: {
                poliza: null,
                id: null,
                status: null,
                type: null,
                productos: null,
                ejecutivoOperacion: null,
                cliente: null,
                newCliente: null,
                agente: null,
                newAgente: null,
                landing: null,
                leadId: null,
                anterior: null,
                emitidaCheck: null,
                emitidDate: null,
                primerPagoCheck: null,
                primerPagoDate: null,
                canceladaCheck: null,
                canceladaDate: null,
                canceladaMotivo: null,
                finalizadaCheck: null,
                finalizadaDate: null,
                emisionDate: null,
                finalizadaMotivo: null,
                inicioDate: null,
                finDate: null,
                periodicidad: null,
                periodicidadNumber: null,
                primaNeta: null,
                primaTotal: null,
                montoPrimerPago: null,
                montoSubsecuente: null,
                formaPago: null,
                numeroCuotas: null,
                primerPagoPolizaDate: null,
                noCuotasPagadas: null,
                creadoPorDate: null,
                creadoPor: null,
                ultimaModoficacionDate: null,
                ultimaModoficacion: null,
                observaciones: null,
                nombres: null,
                apellidoPaterno: null,
                apellidoMaterno: null,
                fechaNacimiento: null,
                selectedGenero: null,
                celular: null,
                correoElectronico: null,
                estadoRepublicaSelected: null,
                codigoPostal: null,
                modelo: null,
                marca: null,
                submarca: null,
                version: null,
                detalleAuto: null,
                plan: null,
                razonSocial: null,
                regimen: null,
                origenAuto: null,
                usoAuto: null,
                noMotor: null,
                noSerie: null,
                placas: null,
                notas: null,
                canceladaFinalizadaMotivo: null,
                rfc: null,
                tipo_cliente: null,
                tipo_contratante: null,
                lead_id: null,
                años_construccion: null,
                tipo_construccion: null,
                num_pisos: null,
                piso_vive: null,
                reactivadaDate: null,
                renovadaDate: null,
                renovadaNum: null,
                mesMembresia: null,
                reactivacion: null,
                polizaAseguradora: null
            },
            correoAgente: null,
            years: null,
            productos: [],
            cuotas: [],
            nombreCliente: "",
            documentos: [],
            correos: [],
            tipos_contratante: [
                { text: "Propietario", value: "propietario" },
                { text: "Inquilino", value: "inquilino" },
            ],
            emision: null,
            uuid: this.$route.params.uuid,
            productoAseguradora: null,
            motivosCancelacionFiltrados: [],
            tipoItems: ["Nota", "Documento"],
            leadSinAsignar: true,
            jsonEndosoInfo: null,
            hasEndoso: false,
            comercialAsignado: "",
            facturacionItems: [
                {
                    text: "Sí",
                    value: true,
                },
                {
                    text: "No",
                    value: false,
                },
            ],
            tipoRegimenItems: [
                "Sueldos y Salarios e Ingresos Asimilados a Salarios",
                "Arrendamiento",
                "Régimen de Enajenación o Adquisición de Bienes",
                "Demás ingresos",
                "Residentes en el Extranjero sin Establecimiento Permanente en México",
                "Ingresos por Dividendos (socios y accionistas)",
                "Personas Físicas con Actividades Empresariales y Profesionales",
                "Ingresos por intereses",
                "Régimen de los ingresos por obtención de premios",
                "Sin obligaciones fiscales",
                "Incorporación Fiscal",
                "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
                "Régimen Simplificado de Confía",
                "",
            ],
            conceptoCFDIItems: [
                "Gastos en general",
                "Primas por seguros de gastos médicos",
                "Sin efectos fiscales",
            ],
            showConfirmationDialog: false,
            renovatePolicy: false,
            productoRenovable: false,
            showRenovationModal: false,
            showRenovationUpdateModal: false,
            canUpdatePolicy: false

        };
    },
    methods: {
        policySuccess() {
            window.location.reload();
        },
        filterOnlyCapsText(value, search) {
            return (
                value != null &&
                search != null &&
                typeof value === "string" &&
                value
                    .toString()
                    .toLocaleUpperCase()
                    .indexOf(search) !== -1
            );
        },
        goBack() {
            if (this.infoLead?.uuid) {
                return this.$router.push(`/bradescard/leads-bradescard/lead/${this.infoLead.uuid}`);
            } else if(window.history.length > 1) {
                return this.$router.go(-1);

            } else{
                return this.$router.push('/');
            }
        },

        verEmisionEditable() {
            this.$router.push(`/actualizar-emision/${this.uuid}`);
        },
        async obtenerProducto(id) {
            const response = await getProductoById(id);
            this.currentProducto = response.data.producto;

        },
        verDetalleCorreo(correo) {
            this.dialogCorreo = true;
            this.correoOpen = correo;
        },
        verDocumento(documento) {
            this.dialogDetalleDocumentos = true;
            this.detallesDocumento = documento;
        },
        fetchMotivosCancelacion() {
            const filters = {
                // rol: JSON.parse(localStorage.roles)[0].rol,
                status: 1,
                tipo_producto: this.currentProducto.tipo_producto,
                producto_aseguradora: this.currentProducto.producto_aseguradora || null,
            };
            getMotivosCancelacion(filters).then(({ motivos_cancelacion }) => {
                let motivos = motivos_cancelacion;
                const motivoActual = this.poliza?.canceladaFinalizadaMotivo;

                if (motivoActual && !motivos.find(m => m.motivoCancelacion === motivoActual)) {
                    motivos.push({
                        motivoCancelacion: motivoActual,
                    });
                }

                this.motivosCancelacionFiltrados = motivos;
            });
        },


        async cargarEmision() {
            const uuid = this.$route.params.uuid;
            if (!uuid) {
                console.error("UUID no definido");
                return;
            }
            const emisionResponse = await getEmisionById(uuid);
            if (!emisionResponse) {
                this.leadSinAsignar = false;
            }
            this.emision = { ...JSON.parse(emisionResponse.requestJson), ...emisionResponse };
            if (typeof emisionResponse.endosoJson != "undefined") {
                this.jsonEndosoInfo = JSON.parse(emisionResponse.endosoJson);
                if (this.jsonEndosoInfo.length > 0) {
                    this.hasEndoso = true;
                }
            }
            if (this.emision.response === typeof "object") {
                this.emision.response = JSON.parse(this.emision.response);
                this.$nextTick(() => this.checkApiError());
            }

            this.load = true;
            if (this.emision.aseguradoraId == 3) {
                const cotizacionResponse = await getCotizacionById(this.emision.cotizacionId);
                this.cotizacion = cotizacionResponse.cotizacion;
            }
            //Obtener Documentos
            emisionResponse.documentos
                ? emisionResponse.documentos.map((element) => {
                    this.documentos.push({
                        nombre: element.nombre ? element.nombre : "No Disponible",
                        fecha: element.fecha
                            ? moment
                                .utc(element.fecha)
                                .subtract(6, "hours")
                                .format("DD/MM/YYYY HH:mm")
                            : "No Disponible",
                        tipo: element.tipo ? element.tipo : "No Disponible",
                        tipoDocumento: element.tipoDocumento
                            ? element.tipoDocumento
                            : "No Disponible",
                        descripcion: element.nota ? element.nota : "No Disponible",
                        creadoPor: element.creadoPor
                            ? element.creadoPor
                            : "No Disponible",
                        url: element.url,
                    });
                })
                : "";
            //Obtener Emails
            emisionResponse.correos
                ? emisionResponse.correos.map((element) => {
                    this.correos.push({
                        asunto: element.subject,
                        fecha: element.fecha
                            ? moment
                                .utc(element.fecha)
                                .subtract(6, "hours")
                                .format("DD/MM/YYYY HH:mm")
                            : null,
                        cuerpo: element.cuerpo,
                        remitente: element.remitente,
                    });
                })
                : "";

            this.nombreCliente =
                this.emision.nombre +
                " " +
                this.emision.apellidoPaterno +
                " " +
                this.emision.apellidoMaterno;
            this.poliza.poliza = this.emision.poliza
                ? this.emision.poliza
                : this.emision.id;

            this.poliza.id = this.emision.id;
            this.poliza.reactivacion = this.emision.reactivacion ? "Sí" : "No";
            this.poliza.interaccion_aseguradora = this.emision.interaccionAseguradora;
            this.poliza.isErrorEscalado = this.emision.errorEscalado;

            this.poliza.globalInteractionId = this.emision.globalInteractionId
                ? this.emision.globalInteractionId
                : "";

            if (this.poliza.globalInteractionId == "0000") {
                this.actualizarGlobalInteractionId();
            }

            this.poliza.status = getStatusEmisionNombre(this.emision.status)

            this.poliza.type = this.emision.tipoPoliza;
            this.poliza.ejecutivoOperacion = parseInt(this.emision.operadorId);
            this.poliza.agente = this.emision.agenteId;
            this.correoAgente = this.emision.correoAgente
                ? this.emision.correoAgente
                : null;
            this.poliza.landing = this.emision.campania;
            this.poliza.leadId = null;
            this.poliza.anterior = this.emision.polizaAnterior;
            this.poliza.emitidaCheck = null;
            this.poliza.polizaSustituida = emisionResponse.polizaSustituida;
            this.poliza.emitidDate = null;
            this.poliza.primerPagoCheck = null;
            this.poliza.primerPagoDate = null;
            this.poliza.canceladaCheck = null;
            this.poliza.emisionDate = this.emision.fechaEmision
                ? moment(this.emision.fechaEmision, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.canceladaDate = this.emision.fechaCancelacion
                ? moment(this.emision.fechaCancelacion, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.canceladaMotivo = null;
            this.poliza.finalizadaCheck = null;
            this.poliza.finalizadaDate = this.emision.fechaFinalizacion
                ? moment(this.emision.fechaFinalizacion, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.finalizadaMotivo = null;
            this.poliza.inicioDate = this.emision.inicio
                ? moment(this.emision.inicio, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.fechaPrimerPago = this.emision.fechaPrimerPago
                ? moment(this.emision.fechaPrimerPago, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.finDate = this.emision.fin
                ? moment(this.emision.fin, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.periodicidad =
                this.emision.pagoId == 1
                    ? "Anual"
                    : this.emision.pagoId == 2
                        ? "Semestral"
                        : this.emision.pagoId == 3
                            ? "Trimestral"
                            : "Mensual";
            this.poliza.periodicidadNumber = this.emision.pagoId;
            this.poliza.reactivadaDate = this.emision.fechaReactivacion
                ? moment(this.emision.fechaReactivacion, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.renovadaDate = this.emision.inicio
                ? moment(this.emision.inicio, "YYYY-MM-DD").subtract(1, "days").format("DD/MM/YYYY")
                : null;
            this.poliza.renovadaNum = this.emision.renovacion;
            this.years = this.emision.anios ? this.emision.anios : 1;
            this.poliza.primaNeta = this.emision.primaNeta;
            this.poliza.primaTotal = this.emision.total;
            this.poliza.montoPrimerPago = this.emision.primerPago;
            this.poliza.montoSubsecuente = this.emision.subsecuentePago;
            this.poliza.formaPago = getFormaPagoNombre(this.emision.formaPago)
            this.poliza.primerPagoPolizaDate = null;
            this.poliza.noCuotasPagadas = null;
            this.poliza.creadoPorDate = moment
                .utc(this.emision.fecha)
                .subtract(6, "hours")
                .format("DD/MM/YYYY HH:mm");
            this.poliza.creadoPor = this.emision.creadoPor
                ? this.emision.creadoPor
                : "";
            this.poliza.cliente = this.emision.cliente;
            this.poliza.ultimaModoficacionDate = moment
                .utc(this.emision.ultimaModificacion)
                .subtract(6, "hours")
                .format("DD/MM/YYYY HH:mm");
            this.poliza.ultimaModoficacion = this.emision.modificadoPor
                ? this.emision.modificadoPor
                : "No Disponible";
            this.poliza.observaciones = this.emision.observaciones;
            this.poliza.nombres = this.emision.nombre;
            this.poliza.apellidoPaterno = this.emision.apellido_paterno;
            this.poliza.apellidoMaterno = this.emision.apellido_materno;
            this.poliza.selectedGenero = this.emision.genero;
            this.poliza.correoElectronico =
                this.emision.status != 0
                    ? `${this.emision.correoContacto.slice(0, 3)}${"*".repeat(
                        this.emision.correoContacto.split("@")[0].length - 3
                    )}@${this.emision.correoContacto.split("@")[1]}`
                    : this.emision.correoContacto;
            this.poliza.estadoRepublicaSelected = getEstadoNombre(this.emision.estadoId),
                (this.poliza.codigoPostal = this.emision.codigoPostal);
            this.poliza.modelo = this.emision.modelo;
            this.poliza.marca = this.emision.marca;
            this.poliza.submarca = this.emision.submarca;
            this.poliza.version = this.emision.nombreVehiculo;
            this.poliza.detalleAuto = this.emision.detalleAuto;
            this.poliza.plan =
                this.emision.planId == 1
                    ? "Amplia"
                    : this.emision.planId == 14
                        ? "Amplia Plus"
                        : this.emision.planId == 3
                            ? "Limitada"
                            : "RC_reglamentaria";
            this.poliza.razonSocial = this.emision.razonSocial
                ? this.emision.razonSocial
                : null;
            this.poliza.origenAuto = this.emision.origenAuto;
            this.poliza.usoAuto = this.emision.usoAuto;
            this.poliza.noMotor = this.emision.numMotor;
            this.poliza.noSerie = this.emision.numSerie;
            this.poliza.placas = this.emision.placas;
            this.poliza.notas = this.emision.notas;
            this.poliza.rfc = this.emision.rfc;
            this.poliza.canceladaFinalizadaMotivo = this.emision.motivoCancelacion;
            this.poliza.productos = this.emision.productoId;
            this.poliza.newCliente =
                this.emision.nombre +
                " " +
                this.emision.apellidoPaterno +
                " " +
                this.emision.apellidoMaterno;
            this.poliza.estadoRepublicaSelected = this.emision.estadoId;
            this.poliza.mesMembresia = this.emision.numeroMes;
            let jsonFormat = JSON.parse(this.emision.requestJson);
            this.poliza.statusCivil = jsonFormat.estado_civil;
            this.poliza.calle = jsonFormat.calle;
            this.poliza.num_exterior = jsonFormat.num_exterior;
            this.poliza.num_interior = jsonFormat.num_interior;
            this.poliza.colonia = jsonFormat.colonia;
            this.poliza.municipio = jsonFormat.municipio;
            this.poliza.id = this.emision.id;
            this.poliza.uuid = this.emision.uuid;
            this.poliza.checkgetCertificado = jsonFormat.checkgetCertificado;
            this.poliza.regimen = jsonFormat.tipo_persona;
            this.poliza.genero = jsonFormat.genero;
            this.poliza.direccion = jsonFormat.direccion;
            this.poliza.fechaNacimiento = jsonFormat.fecha_nacimiento
                ? moment(jsonFormat.fecha_nacimiento, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.celular =
                this.emision.status != 0
                    ? `******${this.emision.telefonoContacto.slice(6, 10)}`
                    : this.emision.telefonoContacto;
            this.poliza.tipo_cliente = jsonFormat.tipo_cliente
                ? jsonFormat.tipo_cliente.toLowerCase()
                : "";
            (this.poliza.tipo_contratante = jsonFormat.tipo_contratante
                ? jsonFormat.tipo_contratante
                : null),
                (this.poliza.años_construccion = jsonFormat.años_construccion
                    ? jsonFormat.años_construccion
                    : null);
            this.poliza.tipo_construccion = jsonFormat.tipo_construccion
                ? jsonFormat.tipo_construccion
                : null;
            this.poliza.num_pisos = jsonFormat.num_pisos
                ? jsonFormat.num_pisos
                : null;
            this.poliza.piso_vive = jsonFormat.piso_vive
                ? jsonFormat.piso_vive
                : null;
            this.comercialAsignado = this.emision.comercialAsignado
                ? this.emision.comercialAsignado
                : null;
            this.poliza.facturar = jsonFormat.facturar || false;
            this.poliza["regimen-fiscal"] = jsonFormat["regimen-fiscal"] || null;
            this.poliza.cfdi = jsonFormat.cfdi || null;

            if (
                this.poliza.tipo_contratante != null &&
                this.poliza.años_construccion != null &&
                this.poliza.tipo_construccion != null &&
                this.poliza.num_pisos != null &&
                this.poliza.piso_vive != null
            ) {
                this.productoAseguradora = "Hogar";
            }

            this.poliza.polizaAseguradora = this.emision.polizaAseguradora
                ? this.emision.polizaAseguradora
                : "";


            if (typeof this.poliza.cliente != "undefined") {
                this.obtenerCliente(this.poliza.cliente);
            }
            if (typeof this.poliza.agente != "undefined") {
                this.obtenerAgente(this.poliza.agente);
            }
            await this.obtenerProducto(this.poliza.productos);
            await this.canRenovate();
            this.canUpdatePolizaAseguradora();

        },
        async cargarLead() {
            if (this.emision.lead_id == null) return;
            const response = await getLeadBradescardById(this.emision.lead_id);
            this.infoLead = response;


        },
        checkApiError() {
            if (this.hasError && this.isAdmin) {
                this.errorApiDialog = true;
            }
        },
        async cargarCuotasDePoliza() {
            const response = await getCuotasByEmisionId(this.$route.params.uuid);

            this.cuotas = response.map((element) => ({
                status: element.status,
                valorPagar: `$${element.valorAPagar}`,
                fechaPagoAcordada: element.fechaPagoAcordada
                    ? moment(element.fechaPagoAcordada, "YYYY-MM-DD").format("DD/MM/YYYY")
                    : "No Disponible",
                uuid: element.uuid,
            }));
        },
        verCuota(uuid) {
            this.$router.push(`/visualizacion-comisiones/${uuid}`);
        },
        obtenerCliente(cliente) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            this.$axios.get(`/v1/cliente/id/${cliente}`, config).then((resp) => {
                // console.log("Cliente: ", resp.data);
                this.poliza.newCliente =
                    `${resp.data.nombre}` +
                    " " +
                    `${resp.data.apellidoPaterno}` +
                    " " +
                    `${resp.data.apellidoMaterno}`;
            });
        },
        obtenerAgente(agente) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            this.$axios.get(`/v1/agente/id/${agente}`, config).then((response) => {
                // console.log("Agente: ", response.data);
                this.poliza.newAgente =
                    `${response.data.nombre}` +
                    " " +
                    `${response.data.apellidoPaterno}` +
                    " " +
                    `${response.data.apellidoMaterno}`;
            });
        },
        toCurrency(number) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            return formatter.format(number); /* $2,500.00 */
        },
        async sendMailErrorAseguradora() {
            try {
                if (!this.poliza.interaccion_aseguradora) {
                    this.$toast.error("No es posible continuar debido a la falta de información");
                    return;
                }
                if (this.poliza.isErrorEscalado) {
                    this.$toast.info("Ya se ha escalado el incidente, pregunta por el status", {
                        position: "top-right",
                        timeout: 5000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false,
                    });
                    return;
                }
                let interaccion = {};
                try {
                    interaccion = JSON.parse(this.poliza.interaccion_aseguradora ?? '{}');
                } catch (error) {
                    this.$toast.error("Error parseando interaccion_aseguradora:");
                    interaccion = {};
                }
                const body = {
                    url: interaccion?.url ?? null,
                    body: interaccion?.request ?? null,
                    response: interaccion?.response ?? null,
                    mensaje: interaccion?.message ?? null,
                    id: this.poliza?.id ?? null
                };
                const result = await sendMailEscaladoAseguradora(body);
                if (result.success === false) {
                    throw result;
                }
                this.$toast.success("Correo enviado con éxito");
                location.reload();
            } catch (error) {
                this.$toast.error(error.message || "Error enviando el mail");
            } finally {
                this.showEscalarAseguradoraConfirmDialog = false;
            }
        },
        actualizarGlobalInteractionId() {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };

            let request = {
                id: this.poliza.id,
                inbound: true,
                agente: "707",
            };
            this.actualStatus = request.status;
            this.$axios
                .post("/v1/emision/manual/actualizar", request, config)
                .then(() => {
                    // console.log("listo");
                });
        },
        async canRenovate() {
            this.renovatePolicy = false;
            this.productoRenovable = false;
            if (![1, 2, 3, 6].includes(this.emision.status)) return;
            if (!this.hasManualRenewalRole) return;
            if (this.currentProducto === null) return;
            const response = await emisionRenovarProductos()
            this.productoRenovable = response.data.some((item) => {
                const productoCoincide =
                    this.currentProducto?.producto_aseguradora ==
                    item.producto_aseguradora;
                return productoCoincide;
            });
            this.renovatePolicy = this.manualRenewalDisabledReason === "";
        },
        canUpdatePolizaAseguradora() {
            console.log("Emision es ", this.emision)
            if (!["ADMIN", "GESTORDATOS"].includes(this.rolesList)) return;

            if (this.emision.detalleProducto.producto_aseguradora != "Vida-Ahorro")
                return

            if (this.emision.tipoPoliza != "Renovacion")
                return

            this.canUpdatePolicy = true;
        },
        renovarManualmente() {
            if (!this.renovatePolicy) return;
            this.loading = true;
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            this.$axios
                .get(`/v1/emision/renovar/${this.emision.id}`, config)
                .then((response) => {
                    const nuevaEmision = response.data;
                    this.$router.push(`/emision/${nuevaEmision.id}`);
                })
                .catch((error) => {
                    this.$toast.error("Hubo un error al intentar renovar la póliza.");
                    console.error("Error en renovación manual:", error);
                })
                .finally(() => {
                    this.loading = false;
                    this.showRenovationModal = false;
                });
        },

        async actualizarPolizaRenovacion() {
            this.loading = true;

            try {
                const res = await actualizarPolizaAseguradoraRenovacion(this.emision.id);

                if (res.success === true) {
                    this.$toast.success(res.message);
                    this.poliza.polizaAseguradora = res.data.poliza_aseguradora;
                } else {
                    this.$toast.error(res.message || "La operación no fue exitosa.");
                }

            } catch (error) {
                const status = error.response?.status;
                const data = error.response?.data;

                if (status === 409) {
                    this.$toast.warning(data?.message || "La póliza ya está actualizada.");

                } else if (status === 400) {
                    this.$toast.error(data?.message || "Error en la operación.");

                } else if (status === 500) {
                    this.$toast.error("Error interno del servidor.");

                    // fallback
                } else {
                    this.$toast.error("Hubo un error al intentar actualizar la póliza.");
                }

                console.error("Error al actualizar la póliza:", error);
            } finally {
                this.loading = false;
                this.showRenovationUpdateModal = false;
            }
        }

    },
    watch: {
        "poliza.fechaNacimiento"(newValue) {
            var years = moment(newValue, "DD/MM/YYYY");
            var today = moment().format("DD/MM/YYYY");
            var diference = moment(today, "DD/MM/YYYY").diff(
                moment(years, "DD/MM/YYYY"),
                "years"
            );
            this.poliza.edad = diference;
        },
        years(value) {
            if (value.typeof != "number") {
                // console.log("No es number")
                this.years = parseInt(value);
                const meses = this.years * 12;
                // console.log("Calculando cuotas: ", meses);
                switch (this.poliza.periodicidadNumber) {
                    case 1:
                        this.poliza.numeroCuotas = meses / 12;
                        break;
                    case 2:
                        this.poliza.numeroCuotas = meses / 6;
                        break;
                    case 3:
                        this.poliza.numeroCuotas = meses / 3;
                        break;
                    case 4:
                        this.poliza.numeroCuotas = meses / 1;
                        break;
                    default:
                        break;
                }
            }
        },
        showResponse: {
            immediate: true,
            handler(newVal) {
                this.errorApiDialog = newVal;
            }
        },

        'emision.response': {
            handler() {
                if (this.showResponse) {
                    this.errorApiDialog = true;
                }
            },
            deep: true
        },
        "$route.path"() {
            location.reload();
        },
    },
    currentProducto: {
        handler() {
            this.fetchMotivosCancelacion();
        },
        deep: true
    },

    async mounted() {
        await this.cargarEmision(),
        await this.cargarLead(),
        await this.cargarCuotasDePoliza();
        await this.fetchMotivosCancelacion();
    },
};
</script>

<style scoped>
.v-stepper__step__step {
    background-color: white;
}

.border-red {
    border: 3px solid red !important;
    border-radius: 4px;
}

.dialog-title {
    justify-content: center;
    display: flex;
}

.justify-center {
    text-justify: auto;
}

.text-red {
    color: red;
}

.text-white {
    color: white;
}

.text-black {
    color: black;
}
</style>
